import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ROUTES } from '@constants/routes';
import { AppStartGuard } from '@guards/app-start.guard';
import { NoQuoteGuard } from '@guards/no-quote.guard';
import { NotPurchasedGuard } from '@guards/not-purchased.guard';
import { PurchasedGuard } from '@guards/purchased.guard';
import { QuoteRetrievalGuard } from '@guards/quote-retrieval.guard';
import { PetInformationComponent } from '@pages/pet-information/pet-information.component';
import { RetrieveComponent } from '@pages/retrieve/retrieve.component';

import { OrganicRouteGuard } from './guards/organic-route.guard';

const routes: Routes = [
	{
		/** If we want a queryparam to be required we'll have to make a new route */
		path: ROUTES.PET_INFORMATION,
		component: PetInformationComponent,
		data: { step: 1 },
		canActivate: [AppStartGuard]
	},
	{
		path: ROUTES.RETRIEVE_WITH_TYPE,
		component: RetrieveComponent,
		data: { step: 1 },
		canActivate: [QuoteRetrievalGuard]
	},
	{
		path: ROUTES.RETRIEVE,
		component: RetrieveComponent,
		data: { step: 1 },
		canActivate: [QuoteRetrievalGuard]
	},
	{
		path: ROUTES.SELECT_A_POLICY,
		loadChildren: () => import('@pages/select-a-policy/select-a-policy.module').then(m => m.SelectAPolicyModule),
		data: { step: 2 },
		canLoad: [NoQuoteGuard],
		canActivate: [PurchasedGuard]
	},
	{
		path: ROUTES.CONTACT_INFORMATION,
		loadChildren: () => import('@pages/contact-info/contact-info.module').then(m => m.ContactInfoModule),
		data: { step: 3 },
		canLoad: [NoQuoteGuard],
		canActivate: [PurchasedGuard]
	},
	{
		path: ROUTES.CONGRATULATIONS,
		loadChildren: () => import('@pages/celebration/celebration.module').then(m => m.CelebrationModule),
		data: { step: 4 },
		canLoad: [NotPurchasedGuard]
	},
	{
		path: ROUTES.ERROR,
		loadChildren: () => import(`@pages/error/error.module`).then(m => m.ErrorModule),
		canActivate: [OrganicRouteGuard]
	},
	{
		path: ROUTES.PREQUOTE,
		loadChildren: () => import(`@pages/prequote/prequote.module`).then(m => m.PrequoteModule)
	},
	{
		path: '',
		redirectTo: ROUTES.PET_INFORMATION,
		pathMatch: 'full'
	},
	{
		path: '**',
		redirectTo: ROUTES.PET_INFORMATION
	}
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes, {
			paramsInheritanceStrategy: 'always',
			scrollPositionRestoration: 'top'
		})
	],
	exports: [RouterModule]
})
export class AppRoutingModule {}
